import { render, staticRenderFns } from "./RipaNumberInput.vue?vue&type=template&id=145a944a"
import script from "./RipaNumberInput.vue?vue&type=script&lang=js"
export * from "./RipaNumberInput.vue?vue&type=script&lang=js"
import style0 from "./RipaNumberInput.vue?vue&type=style&index=0&id=145a944a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports